import React from "react";
import Common from "../../Common";
import { Link, Redirect } from "react-router-dom";
import Header from "./../../Header";
import Form from "react-jsonschema-form";
import { systemVariables } from "./systemVariables";
import Creatables from "./Creatables";
import ToolBarNotification from "../editor/ToolBarNotification";
import Select from "react-select";
import Back from "../UI/Back";
import NotificationMessage from "./NotificationMessage";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
class EditNotifications extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      isLoading: true,
      filteredList: [],
      filteredData: [],
      role: has_local_data ? localdata.data.role : [],
      role_uuid: has_local_data ? localdata.data.role_id : "",
      localdata: localdata,
      message_type: "",
      commondata: "",
      message: "",
      data: [],
      fields: {},
      notificationData: {},
      notificationCode: "",
      notificationName: "",
      notificationContent: "",
      notificationSendTo: "",
      notificationSendCC: "",
      notificationSubject: "",
      error_message: "",
      error: "",
      formData: [],
      notificationSendToOriginalArray: {},
      finalData: {},
      open: false,
      sendTo: "",
      systemVariablesList: [],
      systemVariablesData: systemVariables,
      notificationSystemVariableArray: [],
      sendToDeleted: [],
      sendCCDeleted: [],
      app_token: props.location.state ? props.location?.state?.app_token : null,
      attribute_set_key: props.location.state
        ? props.location.state.attribute_set_key
        : null,
      event_id: props.location.state ? props.location.state.event_id : null,
      event_name: props.location.state ? props.location.state.event_name : null,
      attribute_set_name: props.location.state
        ? props.location.state.attribute_set_name
        : null,
      notification_tag_code: props.location.state
        ? props.location.state.notification_tag_code
        : null,
      notification_variable: props.location.state
        ? props.location.state.notification_variable
        : null,
      event_id1: [],
      notification_attribute: [],
      app_token1: "",
      attribute_set_key1: "",
      notification_code: "",
      notification_content: "",
      notification_send_from: "",
      notification_send_to: "",
      notification_subject: "",
      isChecked: false,
      notification_title: "",
      defaultArray_TO: [],
      defaultArray_CC: [],
      creatableInputTo: "",
      creatableInputCC: "",
      notification_message: [],
      errors: {},
      variablename: "{$variablename}",
      variable_name: "$variablename",
      attribute: [],
    };
    this.schema = {
      type: "object",
      "ui:formButtons": { submit: "Envoyer" },
    };
    this.onEditorChange = this.onEditorChange.bind(this);
    this.addTags = this.addTags.bind(this);
    this.onChangeSubject = this.onChangeSubject.bind(this);
    this.openPopop = this.openPopop.bind(this);
    this.config = {};
    this.config.allowedContent = true;
    this.config.coreStyles_bold = {
      // For Fixing the Bold Issue
      element: "font",
      attributes: { style: "font-weight: bold;" },
      overrides: "strong",
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }
  async componentDidMount() {
    const data = this.getCommonData();
    document.title = "Settings | Notifications";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    let isLoggedin = this.checklogion();
    if (isLoggedin == false) {
      this.props.history.push("/login");
    }
    this.setState({ ...this.state, commondata: { ...data } });
    await fetch(this.state.apiUrl + "edit-notification", {
      method: "post",
      body: JSON.stringify({
        app_token: data.app_token,
        attribute_set_key: this.props.match.params.attribute_set_key,
        notification_tag_code: this.state.notification_tag_code,
        event_id: this.state.event_id,
        notification_variable: JSON.parse(this.state.notification_variable),
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        // console.log("Edit Notification Response : ", res);
        const code = res.data[0].code;
        const content = res.data[0].content;
        const name = res.data[0].name;
        const send_from = res.data[0].send_from;
        const send_to = res.data[0].send_to;
        const subject = res.data[0].subject;
        const attachment = res.data[0].attachment;
        this.setState({
          event_id1: res.event_id,
          app_token1: res.app_token,
          attribute_set_key1: res.attribute_set_key,
          notification_attribute: res.attribute,
          notification_code: code,
          notification_content: content,
          notification_title: name,
          notification_send_from: send_from,
          notification_send_to: send_to,
          notification_subject: subject,
          isChecked: attachment,
          attribute: res.attribute,
        });
        let sendTo = JSON.parse(send_to);
        let sendTOArray = [];
        let sendCCArray = [];
        sendTo.to.map((x) =>
          typeof x === "object" ? sendTOArray.push(x.user) : sendTOArray.push(x)
        );
        this.setState({
          defaultArray_TO: sendTOArray,
        });
        sendTo.cc.map((x) =>
          typeof x === "object" ? sendCCArray.push(x.user) : sendCCArray.push(x)
        );
        this.setState({
          defaultArray_CC: sendCCArray,
        });
      });
    $("#system_var_search").on("keyup", function () {
      var value = $(this).val();
      console.log("system var", value);
      $("#system_variable_att tr").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    });
  }

  NotificationMessage = (message) => {
    this.setState({
      notification_message: message,
    });
  };
  cancelAlert = () => {
    this.setState({
      open: false,
    });
  };
  openPopop = (datas) => {
    this.setState({
      open: !this.state.open,
    });
  };
  closeModal() {
    this.setState({
      open: false,
    });
  }

  onChangeSubject(e) {
    var formData = this.state.formData;
    var subject = e.target.value;
    formData["subject"] = subject;
    this.setState({
      formData: formData,
    });
  }
  onEditorChange(evt) {
    var formData = this.state.formData;
    var ckContent = evt.editor.getData();
    this.setState({
      notificationContent: ckContent,
    });
  }
  checkEmail(str) {
    var emailformat = true;
    let filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(str)) {
      emailformat = false;
    } else {
      emailformat = true;
    }
    return emailformat;
  }

  changeTags(event) {
    if (event.key === "Backspace" || event.key === "Delete") {
      var messageTag = "";
      this.setState({
        messageSendToTag: messageTag,
        messageSendCcTag: messageTag,
      });
    }
  }
  addTags(event) {
    var notificationData = this.state.notificationSendTo;
    if (event.key === "Enter" && event.target.value !== "") {
      var sendToTag = event.target.value;
      if (
        sendToTag.startsWith("$") != false ||
        sendToTag.endsWith(".com") != false
      ) {
        notificationData.push(event.target.value);
        this.setState({
          notificationSendTo: notificationData,
        });
        event.target.value = "";
      } else {
        var messageTag =
          "Wrong Input!! Enter system variable starting with $ or email Id";
        this.setState({
          messageSendToTag: messageTag,
        });
      }
    }
  }

  removeTags(index) {
    var notificationData = this.state.notificationSendTo;
    notificationData = [
      ...notificationData.filter(
        (tag) => notificationData.indexOf(tag) !== index
      ),
    ];
    this.setState({
      notificationSendTo: notificationData,
    });
  }
  addCCTags(event) {
    var notificationData = this.state.notificationSendCC;
    if (event.key === "Enter" && event.target.value !== "") {
      var sendCCTag = event.target.value;
      if (
        sendCCTag.startsWith("$") != false ||
        sendCCTag.endsWith(".com") != false
      ) {
        notificationData = [...notificationData, event.target.value];
        this.setState({
          notificationSendCC: notificationData,
        });
        event.target.value = "";
      } else {
        var messageTag =
          "Wrong Input!! Enter system variable starting with $ or email Id";
        this.setState({
          messageSendCcTag: messageTag,
        });
      }
    }
  }
  removeCCTags(index) {
    var notificationData = this.state.notificationSendCC;
    notificationData = [
      ...notificationData.filter(
        (tag) => notificationData.indexOf(tag) !== index
      ),
    ];
    this.setState({
      notificationSendCC: notificationData,
    });
  }
  onToggleCC() {
    var obj = document.getElementById("showcc");
    if (obj.classList.contains("collapsed")) {
      obj.innerHTML = "CC";
    } else {
      obj.innerHTML = "CC";
    }
  }

  handleNotificationName = (event) => {
    this.setState({
      notification_title: event.target.value,
    });
  };
  handleSubject = (event) => {
    this.setState({
      notification_subject: event.target.value,
    });
  };
  onChangeCreatableInputTo = (value) => {
    this.setState({
      creatableInputTo: value,
    });
  };
  onChangeCreatableInputCC = (value) => {
    const newdefaultdata = value.map((item) => item.value);
    this.setState({
      creatableInputCC: value,
      defaultArray_CC: newdefaultdata,
    });
  };
  toolbarData = (data) => {
    this.setState({
      ...this.state,
      toolbarData: data.getData(),
    });
  };
  handleCheckBox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!fields["notification_name"]) {
      formIsValid = false;
      errors["notification_name"] = "This field is required.";
    }
    if (!fields["notification_subject"]) {
      formIsValid = false;
      errors["notification_subject"] = "This field is required.";
    }
    if (!fields["notification_to"]) {
      formIsValid = false;
      errors["notification_to"] = "This field is required.";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  handleUpdate = () => {
    this.setState({
      isLoading: "data-loader",
    });
    const sendCC = [];
    const sendTo = [];
    let default_arr_To = this.state.defaultArray_TO.map((item) => ({
      label: item,
      value: item,
    }));
    let default_arr_CC = this.state.defaultArray_CC.map((item) => ({
      label: item,
      value: item,
    }));
    // const userCC = default_arr_CC.length
    //   ? default_arr_CC.map((item) => sendCC.push(Object.values(item)[1]))
    //   : this.state.creatableInputCC.length
    //   ? this.state.creatableInputCC.map((item) =>
    //       sendCC.push(Object.values(item)[1])
    //     )
    //   : null;

    const userCC =
      this.state.creatableInputCC.length > 0
        ? this.state.creatableInputCC.map((item) =>
            sendCC.push(Object.values(item)[1])
          )
        : this.state.defaultArray_CC.map((it) => sendCC.push(it));
    console.log("send cc", sendCC);
    const userTo = default_arr_To
      ? this.state.creatableInputTo.length
        ? this.state.creatableInputTo.map((item) =>
            sendTo.push(Object.values(item)[1])
          )
        : default_arr_To.map((item) => sendTo.push(Object.values(item)[1]))
      : null;
    let newArr_To = [];
    let newArr_CC = [];
    let notification_sendTo = sendTo.map((item) => {
      let val = JSON.stringify(item);
      if (val.includes("$") === true) {
        var email_get = `${item}`;
        newArr_To.push(email_get);
      } else {
        newArr_To.push({ user: item, user_name: "" });
      }
    });
    let send_TO_values = JSON.stringify(newArr_To);
    let notification_sendCC = sendCC.map((item) => {
      let val = JSON.stringify(item);
      if (val.includes("$") === true) {
        var get_email = `${item}`;
        newArr_CC.push(get_email);
      } else {
        newArr_CC.push({ user: item, user_name: "" });
      }
    });
    let send_CC_values = JSON.stringify(newArr_CC);
    const send_TO_Final = `{\"cc\":${send_CC_values},\"to\":${send_TO_values},\"bcc\":[]}`;

    this.state.fields["notification_name"] = this.state.notification_title;
    this.state.fields["notification_subject"] = this.state.notification_subject;
    this.state.fields["notification_to"] = send_TO_values;
    if (this.handleValidation()) {
      console.log("Data Has been submitted");
    } else {
      console.log("This Fields Are required.");
      return false;
    }
    document.getElementById("add_user_btn").innerHTML = "Sending....";
    document.getElementById("add_user_btn").disabled = true;
    fetch(this.state.apiUrl + "updateNotification", {
      method: "post",
      dataType: "json",
      body: JSON.stringify({
        event_id: this.state.event_id,
        app_token: this.state.commondata.app_token,
        attribute_set_key: this.state.attribute_set_key,
        attachment: this.state.isChecked ? 1 : 0,
        code: this.state.notification_tag_code,
        content: window.btoa(this.state.toolbarData),
        notification_name: this.state.notification_title,
        search_tags: "",
        send_to: send_TO_Final,
        subject: this.state.notification_subject,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        this.setState({
          isLoading: "data-loader-hide",
        });
        if (res.code === 200) {
          this.setState({
            ...this.state,
            message_type: "success",
            message: res.msg,
          });
        } else {
          this.setState({
            ...this.state,
            message_type: "danger",
            message: res.msg,
          });
        }
        this.NotificationMessage(res);
        document.getElementById("add_user_btn").innerHTML = "Update";
        document.getElementById("add_user_btn").disabled = false;
      });
  };
  render() {
    let default_arr_To = this.state.defaultArray_TO.map((item) => ({
      label: item,
      value: item,
    }));
    let default_arr_CC = this.state.defaultArray_CC.map((item) => ({
      label: item,
      value: item,
    }));

    let val = [];
    let send_to_data = JSON.parse(
      JSON.stringify(this.state.notification_send_to)
    );
    let sendto_attributes = send_to_data.match(/\B(\$\w+)/g);
    let sentto_mail_values = send_to_data.match(/\B(\@\w+)/g);
    const {
      app_token,
      attribute_set_key,
      event_id,
      notification_tag_code,
      notification_variable,
      app_token1,
      attribute_set_key1,
      notification_attribute,
      event_id1,
      notification_code,
      notification_content,
      notification_title,
      notification_send_from,
      notification_send_to,
      notification_subject,
      event_name,
      attachment,
    } = this.state;

    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    const { open } = this.state;
    var notification_send_to_Array = Object.values(
      this.state.notificationSendTo
    ).filter((col) => col);
    var notification_cc_Array;
    if (this.state.notificationSendCC != undefined) {
      notification_cc_Array = Object.values(
        this.state.notificationSendCC
      ).filter((col) => col);
    } else {
      notification_cc_Array = [null];
    }
    const event_options = [{ label: event_name, value: event_name }];
    const options = notification_attribute.map((item) => {
      return item;
    });
    const creatableValue = notification_attribute.map((item) => {
      return item.value;
    });
    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <NotificationMessage response={this.state.notification_message} />
        <Header
          brecum_name="Edit Notifications"
          brecum_page={`Edit Notification`}
        />
        <div class="content-wrapper">
          <div class="wrapper">
            <div class="page-content">
              <p className="col-form-label txt-dark d-flex pb-0">
                <Back
                  name="Back"
                  to={`/${attribute_set_key}/manage-notifications`}
                  state={this.props.location.state}
                  className="txt-dark underline-none"
                />
              </p>
              <br></br>
              <div class="cardRow pt-0">
                <div class="card">
                  <div class="card-body p-2">
                    <div class="title fs-5 mb-4">Edit Notification</div>
                    <div class="row g-4 align-items-stretch">
                      <div class="col">
                        <div class="mb-3 row gx-lg-0 gx-xl-3 align-items-center">
                          <label class="col-lg-4 col-xl-4 col-form-label fw-medium txt-dark text-nowrap  _required">
                            Notification Title
                          </label>
                          <div class="col-sm">
                            <input
                              type="text"
                              class="form-control"
                              id=""
                              value={
                                notification_title.length
                                  ? notification_title
                                  : null
                              }
                              placeholder="Notification Title"
                              onChange={this.handleNotificationName}

                              // onChange={this.handleNotificationName}
                            />
                            <span class="error">
                              {this.state.errors["notification_name"]}
                            </span>
                          </div>
                          {/* <div class="col-sm">
                                        
                                         </div> */}
                        </div>
                        <div class="mb-3 row gx-lg-0 gx-xl-3 align-items-center">
                          <label class="col-lg-4 col-xl-4 col-form-label fw-medium txt-dark text-nowrap  _required">
                            Notification Event
                          </label>
                          <div class="col-sm">
                            <Select
                              class="selectpicker w-100 has-invalid"
                              aria-label="Default select example"
                              placeholder="Choose"
                              options={event_options}
                              defaultValue={event_options}
                              isDisabled={true}
                            />
                            {/* <option value={event_id}>{event_name}</option> */}
                            {/* </Select> */}
                          </div>
                        </div>
                      </div>
                      <div class="col-auto opacity-50">
                        <div class="vr h-100 mx-2"></div>
                      </div>
                      <div class="col col-lg-6 col-xl-6">
                        <div class="title">Editor</div>
                        <ul
                          class="nav nav-tabs _custom3 border-bottom mb-4 px-0"
                          id="myTab"
                          role="tablist"
                        >
                          <li class="nav-item" role="presentation">
                            <a
                              class="nav-link active"
                              id="email-tab"
                              data-bs-toggle="tab"
                              href="#email"
                              role="tab"
                              aria-controls="email"
                              aria-selected="true"
                            >
                              Email
                            </a>
                          </li>
                        </ul>
                        <Form
                          className="edit-notification-form"
                          schema={this.schema}
                          uiSchema={this.UiSchema}
                          formData={this.state.formData}
                        >
                          <div class="tab-content" id="myTabContent">
                            <div
                              class="tab-pane fade show active"
                              id="email"
                              role="tabpanel"
                              aria-labelledby="email-tab"
                            >
                              <div class="section-header mb-3">
                                <div class="title text-capitalize">
                                  Enter email notification details
                                </div>
                              </div>
                              <div class="section-body">
                                <div class="mb-2 row g-2 align-items-center">
                                  <div class="mb-2 row g-2 align-items-center">
                                    <label class="col-lg col-xl col-form-label _required">
                                      To
                                    </label>

                                    <div class="col-lg-10">
                                      <div>
                                        <Creatables
                                          value={
                                            this.state.defaultArray_TO
                                              ? this.state.creatableInputTo
                                                ? this.state.creatableInputTo
                                                : this.state.defaultArray_TO.map(
                                                    (item) => ({
                                                      label: item,
                                                      value: item,
                                                    })
                                                  )
                                              : null
                                          }
                                          options={options}
                                          // value={creatableValue}
                                          onChange={(value) =>
                                            this.onChangeCreatableInputTo(value)
                                          }
                                        />
                                        <span class="error">
                                          {this.state.errors["notification_to"]}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* add cc */}
                                  <div class="mb-2 row g-2 align-items-center">
                                    <label class="col-lg col-xl col-form-label">
                                      CC
                                    </label>
                                    <div class="col-lg-10">
                                      <Creatables
                                        value={
                                          this.state.defaultArray_CC
                                            ? this.state.creatableInputCC
                                              ? this.state.creatableInputCC
                                              : this.state.defaultArray_CC.map(
                                                  (item) => ({
                                                    label: item,
                                                    value: item,
                                                  })
                                                )
                                            : null
                                        }
                                        options={options}
                                        // value={creatableValue}
                                        onChange={(value) =>
                                          this.onChangeCreatableInputCC(value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div class="mb-2">
                                    <div class="d-flex justify-content-between my-1">
                                      <label class="form-label _required">
                                        Subject
                                      </label>
                                    </div>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="exampleInputEmail1"
                                      placeholder="Subject"
                                      value={
                                        notification_subject.length
                                          ? notification_subject
                                          : null
                                      }
                                      onChange={this.handleSubject}
                                    />
                                    <span class="error">
                                      {
                                        this.state.errors[
                                          "notification_subject"
                                        ]
                                      }
                                    </span>
                                  </div>
                                  <CKEditor
                                    editor={Editor}
                                    data={this.state.notification_content}
                                    config={{
                                      mention: {
                                        feeds: [
                                          {
                                            marker: "@",

                                            feed: [
                                              {
                                                id: "@subrat",
                                                name: "subrat ranjan panda",
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    }}
                                    onChange={(event, editor) =>
                                      this.toolbarData(editor)
                                    }
                                  />
                                  {/* <ToolBarNotification
                                    toolbarData={this.toolbarData}
                                    content_data={
                                      this.state.notification_content
                                    }
                                  /> */}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-end my-2">
                            <div class="form-check notification-attachment">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value={this.state.isChecked}
                                checked={this.state.isChecked ? true : false}
                                id="flexCheckChecked"
                                onChange={this.handleCheckBox}
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckChecked"
                              >
                                Add Attachment
                              </label>
                            </div>
                            <div
                              class="muBtn _link icon-before txt-dark p-0"
                              data-bs-toggle="modal"
                              data-bs-target="#system-variables-modal"
                              onClick={() =>
                                this.openPopop(this.state.attribute)
                              }
                            >
                              <span class="svg reset">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 1C5.92465 1 1 5.92465 1 12C1 18.0753 5.92465 23 12 23C18.0753 23 23 18.0753 23 12C23 5.92465 18.0753 1 12 1ZM12 5.30435C12.7925 5.30435 13.4348 5.94665 13.4348 6.73913C13.4348 7.53161 12.7925 8.17391 12 8.17391C11.2075 8.17391 10.5652 7.53161 10.5652 6.73913C10.5652 5.94665 11.2075 5.30435 12 5.30435ZM13.913 18.2174H12.9565H11.0435H10.087V17.2609H11.0435V11.0435H10.087V10.087H11.0435H12.9565V11.0435V17.2609H13.913V18.2174Z"
                                    fill="#2F80ED"
                                  />
                                </svg>
                              </span>
                              System variables
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-4">
                      <button
                        class="muBtn _blue _minW"
                        type="submit"
                        id="add_user_btn"
                        onClick={this.handleUpdate}
                      >
                        Update
                      </button>
                    </div>
                    {/* {this.state.open === true ? ( */}
                    <div
                      class="modal fade"
                      id="system-variables-modal"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="addPersionTitle"
                      aria-hidden="true"
                    >
                      <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
                        role="document"
                      >
                        <div class="modal-content">
                          <div class="modal-header pb-2 pt-4 align-items-start">
                            <div class="d-flex flex-column">
                              <h4 class="modal-title">System Variables</h4>
                              <p class="modal-subtitle m-0">
                                To add a system variable please follow below
                                format.
                              </p>
                            </div>
                            <div
                              class="close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </div>
                          </div>

                          <div class="px-4 py-2 mx-2">
                            <div class="searchBox border">
                              <div class="input-group">
                                <div class="input-group-text">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M20.9999 21L16.6499 16.65"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </svg>
                                </div>
                                <input
                                  type="text"
                                  class="form-control ps-0"
                                  aria-label="Sizing example input"
                                  aria-describedby="inputGroup-sizing-sm"
                                  placeholder="Search"
                                  id="system_var_search"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="modal-body py-0">
                            <div class="table-responsive">
                              <table
                                class="table align-center"
                                id="system_variable_att"
                              >
                                <thead>
                                  <tr>
                                    <th>Variables</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.attribute.map((item) => {
                                    return (
                                      <tr>
                                        <td class="py-0">
                                          {item === null ? "" : item.value}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                              <div _ngcontent-c10="" class="note-sec">
                                <h6 _ngcontent-c10="">
                                  Note:{" "}
                                  <span _ngcontent-c10="" class="red">
                                    To add a system variable please follow below
                                    format.
                                  </span>
                                </h6>
                                <ul _ngcontent-c10="">
                                  <li _ngcontent-c10="">
                                    <strong _ngcontent-c10="">
                                      {this.state.variable_name}
                                    </strong>{" "}
                                    for 'To' and 'From' fields
                                  </li>
                                  <li _ngcontent-c10="">
                                    <strong _ngcontent-c10="">
                                      {this.state.variablename}
                                    </strong>{" "}
                                    for 'Subject' and 'Email Content'{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditNotifications;
